import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_SUNRISE_FOUNDATIONS_EXPERIENCE = defineFcm('sunrise_foundations_experience')
	.asJson(
		createShapeNormalizer({
			type: 'record',
			// TODO: Include all pages or groups that should use the Sunrise Foundations experience
			keys: ['supporterFlow', 'starterFlow'] as const,
			optionalValues: true,
			shape: {
				type: 'object',
				optional: true,
				shape: {
					enabled: { type: 'boolean' },
					experimentName: { type: 'string' },
				},
			},
		}),
	)
	.withDefault({})
	.toConfig();
